
import React from "react";
import { SectionTitle } from "@/components/SectionTitle";
import { TreatmentServiceCard } from "@/components/TreatmentServiceCard";

interface TreatmentService {
  title: string;
  description: string;
  imageUrl?: string;
  iconType?: string;
  backgroundColor?: string;
  textColor?: string;
}

interface TreatmentServicesSectionProps {
  title: string;
  subtitle: string;
  description?: string;
  services: TreatmentService[];
  backgroundColor?: string;
  cardStyle?: 'image' | 'icon' | 'gradient';
}

export const TreatmentServicesSection: React.FC<TreatmentServicesSectionProps> = ({
  title,
  subtitle,
  description,
  services,
  backgroundColor = "bg-dental-offwhite",
  cardStyle = 'image',
}) => {
  // Card background color options for gradient style
  const cardBackgrounds = [
    'bg-white', 
    'bg-[#F5F2EE]', 
    'bg-[#E5DEFF]', 
    'bg-[#F7F5FF]',
    'bg-[#EEFBF3]',
    'bg-[#FFF8F0]'
  ];
  
  return (
    <section className={`py-16 md:py-24 ${backgroundColor}`}>
      <div className="container-custom">
        <SectionTitle 
          title={title} 
          subtitle={subtitle}
          description={description}
          alignment="center"
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {services.map((service, index) => {
            // Assign different background colors for gradient style
            const bgColor = cardStyle === 'gradient' 
              ? service.backgroundColor || cardBackgrounds[index % cardBackgrounds.length] 
              : service.backgroundColor || 'bg-white';
              
            return (
              <TreatmentServiceCard 
                key={index}
                title={service.title}
                description={service.description}
                imageUrl={cardStyle === 'image' ? service.imageUrl : undefined}
                backgroundColor={bgColor}
                textColor={service.textColor}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};
